export default __webpack_public_path__ + "static/7i-6779372f04095051c62ed36bc1dcc142.woff";